import {
  Box,
  Flex,
  Container,
  SimpleGrid,
  Text,
  Button,
  Badge,
  Link,
  Center,
  Spinner,
  Fade
} from "@chakra-ui/react";
import React from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import HeyDayView from "./components/HeyDayView";
import GiveMoreView from "./components/GiveMoreView";
import LocationMap from "./components/LocationMap";
import { loadMapData } from "./services/mapdataloader";
import { useTranslation } from 'react-i18next';
import './i18n/i18n';
import LanguageSwitcher from './components/LanguageSwitcher';

import { FaExternalLinkAlt } from "react-icons/fa";

function pathToParams(locparams) {
  const pathname = locparams;
// Remove the leading slash if present
  const pathWithoutLeadingSlash = pathname.startsWith('/') ? pathname.slice(1) : pathname;

// Split the path by slashes to get individual parameters
  const params = pathWithoutLeadingSlash.split('/');
  return params
}
export default function App() {
  const { t } = useTranslation();
  const [state, setState] = React.useState({});
  const [localStrings, setLocalStrings] = React.useState({});
  const [disabled , setDisabled] = React.useState(false)
  const [isHeyDay, setIsHeyDay] = React.useState(false)
  const [isVeritree, setIsVeritree] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [currentFactIndex, setCurrentFactIndex] = React.useState(0);
  const [mapData, setMapData] = React.useState(null);
  var params = new URLSearchParams(window.location.search);
 var  pathParams = pathToParams(window.location.pathname)
 var id = pathParams[0]
var source = params.get("source");
const [gridColumns, setGridColumns] = React.useState(1)

  if (id == null) {
   
    id = "Sample Store";
  }

  React.useEffect(() => {
    if (source == "hd") {
      setIsHeyDay(true)
      setIsLoading(false)
      return 
    }

    if (source == "vt") {
      setIsVeritree(true)
      setIsLoading(false)
      return 
    }

    if (source == "shp") {
      source = "shopify"
      fetch(
        `https://sprout-app.thegoodapi.com/app/public/metrics?id=${id}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data["name"] == null) {
            setDisabled(true)
          }
            
          data["total_planted_trees_month"] = data["total_trees_current_month"]
          data["human_name"] = data["name"]
          data["total_planted_trees"]= data["total_trees_planted"]
          if (data["trees_enabled"] && data["plastics_enabled"]) {
            data["locale_strings"]["partnership_description"] = data["locale_strings"]["combined_description"]
            setGridColumns(2)
          } else if (data["plastics_enabled"]) {
            data["locale_strings"]["partnership_description"] = data["locale_strings"]["plastics_description"]
          }


          setState(data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
        return
    }
    // fetch data from a url endpoint
    fetch(
      `https://sprout-api.thegoodapi.com/api/public/dashboard/${id}/metrics`+
        "?source=" +
        source
    )
      .then((response) => response.json())
      .then((data) => {
        data["plastics_enabled"] = false
        data["trees_enabled"] = true
        setState(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }, []);

  React.useEffect(() => {
    if (state.locale_strings?.fact_2 || state.locale_strings?.fact_3) {
      const timer = setInterval(() => {
        setCurrentFactIndex((prevIndex) => {
          const maxFacts = [
            state.locale_strings?.fact_1,
            state.locale_strings?.fact_2,
            state.locale_strings?.fact_3
          ].filter(Boolean).length;
          
          return (prevIndex + 1) % maxFacts;
        });
      }, 5000);

      return () => clearInterval(timer);
    }
  }, [state.locale_strings]);

  React.useEffect(() => {
    const fetchMapData = async () => {
      try {
        const data = await loadMapData();
        setMapData(data);
      } catch (error) {
        console.error('Error loading map data:', error);
      }
    };
    fetchMapData();
  }, []);

  function mainApp() {
    if (isHeyDay) {
      return <HeyDayView id={id} />;
    }

    if (isVeritree) {
      return <GiveMoreView id={id} />;
    }

    const description = state.locale_strings?.partnership_description || t('partnership_description');
    const combinedDescription = state.locale_strings?.combined_description || t('combined_description');
    const plasticsDescription = state.locale_strings?.plastics_description || t('plastics_description');

    return (
      <Container minWidth="100%" p="0" bgColor="white">
        <Box pt="80px" bgColor="#EDF0F4" px={{ base: "20px", md: "0", lg: "0" }}>
          <Box m="auto" maxWidth="860px" align="center">
            <Flex direction="row" justify="center">
              {state.logo_url ? (
                <>
                  <img src={state.logo_url} width="300px" height="300px" />
                </>
              ) : (
                <Text fontSize="5xl" fontWeight="bold" mb="20px">
                  {state.human_name}
                </Text>
              )}
              <a
                style={{ "text-decoration": "none", "padding-left": "0%" }}
                href={state.url}
              >
                <FaExternalLinkAlt />
              </a>
            </Flex>
            <Badge
              py="4px"
              px="8px"
              borderRadius="16px"
              Variant="subtle"
              colorScheme="teal"
              mb="20px"
            >
              {state.locale_strings?.member_since || "Member since"} {state.member_since}
            </Badge>
            <Text fontSize="xl" fontWeight="light">
              {state.trees_enabled && state.plastics_enabled
                ? combinedDescription
                : state.plastics_enabled
                ? plasticsDescription
                : description}
            </Text>
          </Box>
        </Box>
        <Box py="80px" bgColor="#EDF0F4">
          <Box
            m="auto"
            maxWidth="860px"
            align="center"
            p={{ base: "20px", md: "0", lg: "0" }}
          >
            <Text fontSize="3xl" fontWeight="bold" mb="40px">
              {state.locale_strings?.contributions_title || t('contributions_title')}
            </Text>

            <SimpleGrid
              columns={{ base: 1, md: gridColumns, lg: gridColumns }}
              spacing={{ base: "20px", md: "20px", lg: "20px" }}
            >
              {state.trees_enabled && (
                <Box
                  p={{ base: "4", md: "8", lg: "8" }}
                  borderRadius="24"
                  mb="20px"
                  bgImage="https://uploads-ssl.webflow.com/6129929c4bf93b549649bfa5/6494f7c63c2e7851a851bf60_stat-tree-total.jpg"
                  bgSize="cover"
                  bgRepeat="no-repeat"
                  bgPosition="center"
                  color="white"
                >
                  <Box mb={{ base: "120px", md: "140px", lg: "140px" }} align="left">
                    <Text fontSize="3xl">{state.total_planted_trees}</Text>
                    <Text fontSize="xl">
                      {state.locale_strings?.total_trees_planted || t('total_trees_planted')}
                    </Text>
                  </Box>
                </Box>
              )}
              {state.plastics_enabled && (
                <Box
                  p={{ base: "4", md: "8", lg: "8" }}
                  borderRadius="24"
                  mb="20px"
                  bgImage="https://storage.googleapis.com/treeshop-app-assets/dashboard.thegoodapi.com/plastics_counter_backround.png"
                  bgSize="cover"
                  bgRepeat="no-repeat"
                  bgPosition="center"
                  color="white"
                >
                  <Box mb={{ base: "120px", md: "140px", lg: "140px" }} align="left">
                    <Text fontSize="3xl">{state.total_bottles_registered}</Text>
                    <Text fontSize="xl">
                      {state.locale_strings?.bottles_removed || t('bottles_removed')}
                    </Text>
                  </Box>
                </Box>
              )}
            </SimpleGrid>
          </Box>
        </Box>
        {mapData && state.trees_enabled && (
          <Box py="80px" bgColor="white">
            <Box
              m="auto"
              maxWidth="860px"
              align="center"
              p={{ base: "20px", md: "0", lg: "0" }}
            >
              <Text fontSize="3xl" fontWeight="bold" mb="40px">
                {t('impact_location')}
              </Text>
              <LocationMap data={mapData} />
            </Box>
          </Box>
        )}
        <Box py="80px" bgColor="white">
          <Box
            m="auto"
            maxWidth="860px"
            align="center"
            p={{ base: "20px", md: "0", lg: "0" }}
          >
            <Text fontSize="3xl" fontWeight="bold" mb="40px">
              {state.locale_strings?.more_then_planting_trees || t('more_then_planting_trees')}
            </Text>

            <SimpleGrid
              columns={{ base: "1", md: "3", lg: "3" }}
              spacing={{ base: "0px", md: "20px", lg: "20px" }}
            >
              <Box
                p="8"
                borderRadius="24"
                mb="20px"
                bgImage="https://uploads-ssl.webflow.com/6129929c4bf93b549649bfa5/646be3415a4f7b0cc7a61891_vp_wildlife.jpg"
                bgSize="cover"
                bgRepeat="no-repeat"
                bgPosition="center"
                color="white"
              >
                <Box mb={{ base: "200px", md: "260px", lg: "260px" }}>
                  <Text fontSize="2xl">
                    {state.locale_strings?.revive_habitats || t('revive_habitats')}
                  </Text>
                </Box>
              </Box>
              <Box
                p="8"
                borderRadius="24"
                mb="20px"
                bgImage="https://uploads-ssl.webflow.com/6129929c4bf93b549649bfa5/646be341f224ea71f3040de1_vp-coral.jpg"
                bgSize="cover"
                bgRepeat="no-repeat"
                bgPosition="center"
                color="white"
              >
                <Box mb={{ base: "200px", md: "260px", lg: "260px" }}>
                  <Text fontSize="2xl">
                    {state.locale_strings?.improve_coral_reef_health || t('improve_coral_reef_health')}
                  </Text>
                </Box>
              </Box>
              <Box
                p="8"
                borderRadius="24"
                mb="20px"
                bgImage="https://uploads-ssl.webflow.com/6129929c4bf93b549649bfa5/646be41317d685d1fa75f905_vp-local.jpg"
                bgSize="cover"
                bgRepeat="no-repeat"
                bgPosition="center"
                color="white"
              >
                <Box mb={{ base: "200px", md: "260px", lg: "260px" }}>
                  <Text fontSize="2xl">
                    {state.locale_strings?.support_locals || t('support_locals')}
                  </Text>
                </Box>
              </Box>
            </SimpleGrid>
            <Text fontSize="xl" fontWeight="light">
              {state.locale_strings?.improvement_summery || t('improvement_summery')}
            </Text>
          </Box>
        </Box>
        <Box py="80px" bgColor="#04BD9C" color="white">
          <Box
            m="auto"
            maxWidth="860px"
            align="center"
            p={{ base: "20px", md: "0", lg: "0" }}
          >
            <Box width="90px" height="90px" mb="20px">
              <img src="https://uploads-ssl.webflow.com/6129929c4bf93b549649bfa5/646bc8ab214cf13962675386_did-you-know.png" />
            </Box>
            <Text fontSize="med" fontWeight="bold" mb="20px">
              {state.locale_strings?.did_you_know || t('did_you_know')}
            </Text>

            <Fade
              key={currentFactIndex}
              in={true}
              transition={{ enter: { duration: 0.5 }, exit: { duration: 0.5 } }}
            >
              <Text fontSize="3xl" fontWeight="light" mb="20px">
                {getCurrentFact()}
              </Text>
            </Fade>
          </Box>
        </Box>
        <Box py="40px" bgColor="#3A4148" color="white">
          <Box
            m="auto"
            maxWidth="860px"
            align="center"
            p={{ base: "20px", md: "0", lg: "0" }}
          >
            <Flex>
              <Box mr="80px" align="left">
                <Text fontSize="med" fontWeight="light" align="left">
                  <div dangerouslySetInnerHTML={{ __html: state.locale_strings?.goodapi_mission || t('goodapi_mission') }} />
                </Text>
              </Box>
              <Box></Box>
              <Link href="https://thegoodapi.com" isExternal>
                <Button colorScheme="teal" px="30px">
                  {state.locale_strings?.join_now || t('join_now')}
                </Button>
              </Link>
            </Flex>
          </Box>
        </Box>
      </Container>
    );
  }

  const getCurrentFact = () => {
    const facts = [
      state.locale_strings?.fact_1 || t('fact_1'),
      state.locale_strings?.fact_2,
      state.locale_strings?.fact_3
    ].filter(Boolean);
    
    if (facts.length === 0) {
      return t('fact_1');
    }
    
    return facts[currentFactIndex];
  };

  return (
    <>
      {isLoading ? (
        <Center h="100vh">
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='teal.500'
            size='xl'
          />
        </Center>
      ) : (
        !disabled ? (
          <>
            {!state.locale_strings && <LanguageSwitcher />}
            {mainApp()}
          </>
        ) : <div>/</div>
      )}
    </>
  );
}


